import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enJSON from "./locale/en.json";
import nlJSON from "./locale/nl.json";

import WidgetHelper from "./utils/widgetHelper.tsx";
const language = WidgetHelper.getCurrentLanguage()

i18n.use(initReactI18next).init({
  lng: language || document.documentElement.lang || `en`,
  fallbackLng: `en`,
  resources: {
    en: { ...enJSON },
    nl: { ...nlJSON },
  },
});
